import PropTypes from "prop-types"
import PreSelectedInput from "components/rebalance-widget/components/preselected-input"

export default function FieldCell({ value, isInput, editable, format, onFocus, onBlur, onChange, onKeyDown, useTextField }) {
  if (isInput) {
    return <PreSelectedInput value={value} {...{ onChange, onBlur, onFocus, onKeyDown, useTextField }} />
  }
  // Original row
  if (!editable) {
    return value !== 0 ? format(value) : "-"
  }

  // Non input editable fields
  if (editable) {
    return format(value)
  }
}

FieldCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isInput: PropTypes.bool,
  editable: PropTypes.bool,
  format: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  useTextField: PropTypes.bool,
}
